export default "__VITE_ASSET__COU6UrZT__"